import React from 'react'
import Navbar from '../components/Navbar'
import Contact from '../components/Contact'
import Footer from '../components/Footer'


const Contactpage = () => {
  return (
    <div className='bg-[#333]'>
      <Navbar/>
      <Contact/>
      <Footer/>
    </div>
  )
}

export default Contactpage
